import axios from "axios";

// The public marketing API needs no auth/CSRF and is served on the marketing
// host. A bare axios instance (not the app's authed `api`) keeps it decoupled
// from the CRM session layer.
const publicApi = axios.create({
  headers: { Accept: "application/json" },
});

export async function fetchHomepage() {
  const { data } = await publicApi.get("/api/public/homepage");
  return data;
}

export async function fetchListings(params = {}) {
  const qs = new URLSearchParams();
  ["type", "state", "city", "q"].forEach((k) => {
    if (params[k]) qs.set(k, params[k]);
  });
  const { data } = await publicApi.get(`/api/public/listings?${qs}`);
  return data; // { listings, cities }
}

export async function fetchListing(token) {
  const { data } = await publicApi.get(`/api/public/listings/${token}`);
  return data;
}

export async function submitEnquiry(token, payload) {
  const { data } = await publicApi.post(
    `/api/public/listings/${token}/enquiries`,
    payload,
  );
  return data; // { ok, message } or { ok:false, errors }
}

// A site-wide "Get a quote" enquiry, not tied to a specific listing.
export async function submitGeneralEnquiry(payload) {
  const { data } = await publicApi.post("/api/public/enquiries", payload);
  return data; // { ok, message } or { ok:false, errors }
}
